module.exports = __webpack_public_path__ + "img/WhatsApp.093050af.svg";